(function () {
  'use strict';

  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (prefersReducedMotion) {
    document.querySelectorAll('.ipta-animate, .ipta-image-reveal').forEach((el) => {
      el.classList.add('is-visible');
    });
    return;
  }

  const observerOptions = {
    root: null,
    rootMargin: '0px 0px -10% 0px',
    threshold: 0.15,
  };

  const revealObserver = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        revealObserver.unobserve(entry.target);
      }
    });
  }, observerOptions);

  document.querySelectorAll('.ipta-animate, .ipta-image-reveal').forEach((el) => {
    revealObserver.observe(el);
  });

  // Hero slider content animation
  function initHeroSlider(section) {
    const slides = section.querySelectorAll('.ipta-hero-slide');
    if (!slides.length) return;

    const setActive = (index) => {
      slides.forEach((slide, i) => {
        const content = slide.querySelector('.ipta-slide-content');
        if (!content) return;
        if (i === index) {
          content.classList.add('is-active');
        } else {
          content.classList.remove('is-active');
        }
      });
    };

    // Initial active
    setActive(0);

    // Listen to custom slider events if they exist, or watch transform
    const track = section.querySelector('.ipta-hero-slider__track');
    if (track) {
      const observer = new MutationObserver(() => {
        const transform = track.style.transform;
        const match = transform.match(/translateX\(-?(\d+(?:\.\d+)?)%\)/);
        if (match) {
          const percent = parseFloat(match[1]);
          const index = Math.round(percent / 100) % slides.length;
          setActive(index);
        }
      });
      observer.observe(track, { attributes: true, attributeFilter: ['style'] });
    }

    // Also observe buttons if present
    const prevBtn = section.querySelector('[data-slider-prev]');
    const nextBtn = section.querySelector('[data-slider-next]');
    const dots = section.querySelectorAll('[data-slider-dot]');

    let current = 0;
    const updateCurrent = (index) => {
      current = index;
      setActive(current);
    };

    if (prevBtn) {
      prevBtn.addEventListener('click', () => {
        current = current > 0 ? current - 1 : slides.length - 1;
        updateCurrent(current);
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', () => {
        current = current < slides.length - 1 ? current + 1 : 0;
        updateCurrent(current);
      });
    }
    dots.forEach((dot, i) => {
      dot.addEventListener('click', () => updateCurrent(i));
    });
  }

  document.querySelectorAll('.ipta-hero-slider').forEach(initHeroSlider);
})();
